import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './country-of-residence.component'

let module = angular.module('countryOfResidence', [
  uiRouter
])

.component('countryOfResidence', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/country-of-residence/index.js